//Google Analtyics
import ReactGA from "react-ga4";

export const ExplorePageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Explore Page",
  });
};

export const ProfilePageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Profile Page",
  });
};

export const ProfileHistoryPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Profile History Page",
  });
};

export const TicketsPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Profile Tickets Page",
  });
};

export const LoginPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Login Page",
  });
};

export const OTPButtonClick = () => {
  ReactGA.event("User Login", {
    button_name: "OTP Login",
    user_activity: "Clicked Button",
  });
};

export const EmailButtonClick = () => {
  ReactGA.event("User Login", {
    button_name: "Email Login",
    user_activity: "Clicked Button",
  });
};

export const WelcomePageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Welcome Page",
  });
};

export const WelcomePageButtonClick = () => {
  ReactGA.event("User Login", {
    button_name: "User Name Submit",
    user_activity: "Clicked Button",
  });
};

export const HotelBookingsPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Bookings Page",
  });
};

export const BookingIDSubmitButtonClick = () => {
  ReactGA.event("User Login", {
    button_name: "Booking ID Submit",
    user_activity: "Clicked Button",
  });
};

export const HomePageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Home Page",
  });
};

export const EarlyCheckInSubmitButtonClick = () => {
  ReactGA.event("User Activity", {
    button_name: "Early Check-in Submit",
    user_activity: "Clicked Button",
  });
};

export const DocumentSubmitButtonClick = () => {
  ReactGA.event("User Activity", {
    button_name: "Document Submit",
    user_activity: "Clicked Button",
  });
};

export const LostItemSubmitButtonClick = () => {
  ReactGA.event("User Activity", {
    button_name: "Lost Item Submit",
    user_activity: "Clicked Button",
  });
};

export const ExtendStaySubmitButtonClick = () => {
  ReactGA.event("User Activity", {
    button_name: "Extend Stay Submit",
    user_activity: "Clicked Button",
  });
};

export const RoomChangeSubmitButtonClick = () => {
  ReactGA.event("User Activity", {
    button_name: "Room Change Submit",
    user_activity: "Clicked Button",
  });
};

export const FeedbackSubmitButtonClick = () => {
  ReactGA.event("User Activity", {
    button_name: "Feedback Submit",
    user_activity: "Clicked Button",
  });
};

export const WakeUpCallSubmitButtonClick = () => {
  ReactGA.event("User Activity", {
    button_name: "Wake UP Call Submit",
    user_activity: "Clicked Button",
  });
};

export const CheckOutSubmitButtonClick = () => {
  ReactGA.event("User Activity", {
    button_name: "Check Out Submit",
    user_activity: "Clicked Button",
  });
};

export const DownloadSubmitButtonClick = () => {
  ReactGA.event("User Activity", {
    button_name: "Download App Submit",
    user_activity: "Clicked Button",
  });
};

export const HistoryPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "History Page",
  });
};

export const RoomPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Room Page",
  });
};

export const PickNDropPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Pick & Drop Page",
  });
};

export const PickNDropSubmitButtonClick = () => {
  ReactGA.event("User Booking", {
    button_name: "Pick & Drop Submit",
    user_activity: "Clicked Button",
  });
};

export const InRoomRestaurantPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "InRoom Restaurant Page",
  });
};

export const InRoomFoodMenuPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "InRoom Food Menu Page",
  });
};

export const InroomSubmitButtonClick = () => {
  ReactGA.event("User Booking", {
    button_name: "Inroom Food Order Submit",
    user_activity: "Clicked Button",
  });
};

export const TableReservationRestaurantPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Table Reservation Restaurant Page",
  });
};

export const TableReservationSubmitButtonClick = () => {
  ReactGA.event("User Booking", {
    button_name: "Table Reservation Submit",
    user_activity: "Clicked Button",
  });
};

export const HotelGuidePageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Hotel Guide Page",
  });
};

export const TouristGuidePageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Tourist Guide Page",
  });
};

export const SpaPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Spa Page",
  });
};

export const SpaServicePageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Spa Service Page",
  });
};

export const SpaServiceSubmitButtonClick = () => {
  ReactGA.event("User Booking", {
    button_name: "Spa Service Submit",
    user_activity: "Clicked Button",
  });
};

export const EventPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Event Page",
  });
};

export const EventSubmitButtonClick = () => {
  ReactGA.event("User Booking", {
    button_name: "Event Submit",
    user_activity: "Clicked Button",
  });
};

export const HouseKeepingPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "House Keeping Page",
  });
};

export const HKCommoditySubmitButtonClick = () => {
  ReactGA.event("User Booking", {
    button_name: "HouseKeeping Commodity Submit",
    user_activity: "Clicked Button",
  });
};

export const HKServiceSubmitButtonClick = () => {
  ReactGA.event("User Booking", {
    button_name: "HouseKeeping Service Submit",
    user_activity: "Clicked Button",
  });
};
